/**
 * `outstandingAmountMinorUnits` is a schema-optionality guard, not a status
 * decision: on both `Invoice` and `SupplierInvoice` the field is populated on
 * the list/detail reads the UI actually renders, but typed optional because
 * other reads (a DRAFT-only create/update response, a void response) omit it
 * entirely. A missing value means the API never computed a balance for this
 * response, not that nothing is owed, so the safe default is "assume nothing
 * is settled yet" - the invoice's or supplier invoice's full total.
 *
 * Deliberately shape-typed rather than importing `Invoice` / `SupplierInvoice`:
 * both schemas declare the same `{ totalMinorUnits: number; outstandingAmountMinorUnits?:
 * number }` pair for the same reason, so one guard serves either entity without
 * a false split. Callers needing a status-gated display decision (show the
 * outstanding balance only where one can genuinely still be owed) build on top
 * of this via `resolveInvoiceAmountDisplay` (`components/invoice/InvoiceStatus.tsx`)
 * rather than duplicating the fallback.
 */
export function resolveOutstandingAmountMinorUnits(entity: {
  totalMinorUnits: number;
  outstandingAmountMinorUnits?: number;
}): number {
  return entity.outstandingAmountMinorUnits ?? entity.totalMinorUnits;
}
